
































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import moment from "moment";
import { Claim, ClaimType } from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import ClaimDetail from "@/employee/components/healthcareExpense/ClaimDetail.vue";
import { claimTypeIcon } from "@/shared/awesomeIconMapper";
import { toLower } from "lodash";

@Component({
  components: {
    Pill,
    Button,
    CurrencyAmount,
    ClaimDetail
  },
})
export default class ClaimRow extends Vue {
  claimTypeIcon = claimTypeIcon;
  @Prop() claim: Claim;

  ClaimType = ClaimType;
  isOpen = false;

  get formattedServiceDate (): string {
    return moment(this.claim.serviceDate).format("MMM D, YYYY");
  }

  get additionalProviders (): string {
    if (this.claim.providersCount > 1) {
      const additionalProviders = this.claim.providersCount - 1;
      return `(+${additionalProviders})`;
    }
    else {
      return "";
    }
  }

  toggleDetail (e): void {
    e.preventDefault();
    this.isOpen = !this.isOpen;
  }
}
